<template>
    <div>
        <pageLoader :showLoader="false" :checkDocState=false></pageLoader>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div v-if="!loaded"> Loading...</div>
        <div class="ServiceRequest" v-else v-bind:style="{ background: [getBackgroundColor()]}">
            <div class="Request_wrapper">
                <div class="content">
                    <div class="inner-content">
                        <div v-for="contentItem in getContentItems()" class="content-item">
                            <div v-if="shouldShowItem(contentItem)">
                                <div v-if="contentItem.type == 'changer'">
                                    <b-form-input type="text" placeholder="" class="form-control"
                                                  style="display: none;"
                                                  v-model="contentItem.value"></b-form-input>
                                </div>
                                <div v-if="contentItem.type == 'space'"
                                     :style="{
                                           'height': `${contentItem.height}px`,
                                     }"
                                >
                                </div>
                                <!-- logo -->
                                <div v-if="contentItem.type == 'logo' && contentItem.value"
                                     class="place">
                                    <div class="place_img">
                                        <img :src="contentItem.value" alt="place img"
                                             :style="{ 'aspect-ratio': contentItem.img_aspect_ratio}">
                                    </div>
                                </div>
                                <!-- title -->
                                <div v-if="contentItem.type == 'title'"
                                     class="main_title"
                                     :style="{
                                           'text-align': `${getLabelItemAlignment(contentItem)}`,
                                           'color': `${getLabelItemColor(contentItem)}`,
                                     }"
                                >{{ contentItem.value }}
                                </div>
                                <!-- label -->
                                <div v-if="contentItem.type == 'label'"
                                     class="subtitle"
                                     :style="{
                                           'text-align': `${getLabelItemAlignment(contentItem)}`,
                                           'color': `${getLabelItemColor(contentItem)}`,
                                     }"
                                >{{ getLabelItemText(contentItem) }}
                                </div>
                                <!-- place selector -->
                                <div v-if="contentItem.type == 'place_selector' && !placeGuid" class="input-wrapper additional">
                                    <label class="dropdown-label">{{
                                            contentItem.label
                                        }}{{ contentItem.required ? '*' : '' }}</label>
                                    <model-select :options="places"
                                                  v-model="place"
                                                  :placeholder="contentItem.hint" @input="onPlaceSelected">
                                    </model-select>
                                </div>
                                <!-- question selector -->
                                <div v-if="contentItem.type == 'question_selector'" class="input-wrapper additional">
                                    <label class="dropdown-label">{{
                                            contentItem.label
                                        }}{{ contentItem.required ? '*' : '' }}</label>
                                    <model-select :options="questions"
                                                  v-model="question"
                                                  :placeholder="contentItem.hint" @input="onQuestionSelected">
                                    </model-select>
                                </div>
                                <!-- action_button -->
                                <div
                                    v-if="contentItem.type == 'action_button'"
                                    class="main_button"
                                    :style="{
                                           'background': `${getActionButtonBack(contentItem)}`,
                                           'color': `${getActionButtonTextColor(contentItem)}`,
                                     }"
                                    @click="onSendClick(contentItem)">
                                    <div>{{ contentItem.value }}</div>
                                </div>
                            </div>
                            <div v-else-if="contentItem.type == 'logo'" style="margin-top: 8px;"></div>
                        </div>

                        <profileIconNew :settings="profileIconSettings" v-if="showProfileIcon"></profileIconNew>
                    </div>
                </div>
            </div>
        </div>
        <QRItemsScanner :settings="qrScannerSettings"></QRItemsScanner>
    </div>
</template>

<script>
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapMutations, mapState} from 'vuex';
import customModalDialog from '@/components/widgets/customModalDialog';
import QRItemsScanner from '@/components/widgets/QRItemsScanner';
import profileIconNew from "./voteFlow/widgets/profileIconNew.vue";
import pageLoader from "@/components/widgets/pageLoader";
import "@/assets/css/popapModal.css";
import InlineSvg from 'vue-inline-svg';
import "vue-search-select/dist/VueSearchSelect.css"
import { ModelSelect } from 'vue-search-select'

export default {
    mixins: [mixin, errorMixin],
    components: {
        customModalDialog, profileIconNew, InlineSvg,
        QRItemsScanner,
        pageLoader,
        ModelSelect,
    },
    data() {
        return {
            orgGuid: null,
            placeGuid: null,
            srType: null,
            fullConfig: null,
            loaded: true,
            config: {},
            showProfileIcon: false,
            profileIconSettings: {
                longTapForLogout: false,
                afterLogoutHandler: this.afterLogout,
                showAdminMenu: false,
            },
            inputIsValid: false,
            selectedFile: null,
            customModalSettings: {},
            qrScannerSettings: {},
            place: {},
            question: {},
            places: [],
            questions: [],
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        })
    },
    watch: {},
    async mounted() {
        this.orgGuid = this.$route.params.orgGuid
        this.placeGuid = this.$route.query.p //todo handle auth redirects
        this.srType = this.$route.query.t
        await this.fetchConfig()
    },
    methods: {
        ...mapMutations({
            setProgressBarTag: 'setProgressBarTag',
            removeKeys: 'auth/removeKeys',
        }),
        ...mapActions({
            entryPointInitialData: 'serviceRequest/entryPointInitialData',
            addRequest: 'serviceRequest/addRequest',
            sendRemoteLogAction: 'serviceRequest/sendLog',
        }),
        getLabelItemText(contentItem) {
            return contentItem.value
        },
        getLabelItemAlignment(contentItem) {
            if (!contentItem.align) return "center"
            return contentItem.align
        },
        getLabelItemColor(contentItem) {
            if (!contentItem.color || !contentItem.color.startsWith("#")) return "#000000"
            return contentItem.color
        },
        onQRDetected(dsfsdf) {

        },
        getContentItems() {
            return this.config.content || []
        },
        getBackgroundColor() {
            if (this.config.background) {
                return this.config.background
            } else {
                return '#d5d5d5'
            }
        },
        getActionButtonBack(contentItem) {
            if (this.inputIsValid) {
                return contentItem.active_back || '#7d7d7d'
            } else {
                return contentItem.inactive_back || '#d7d7d7'
            }
        },
        getActionButtonTextColor(contentItem) {
            if (this.inputIsValid) {
                return contentItem.active_color || '#ffffff'
            } else {
                return contentItem.inactive_color || '#ffffff'
            }
        },
        getItemBack(contentItem) {
            return contentItem.back || '#7d7d7d'
        },
        getItemColor(contentItem) {
            return contentItem.color || '#ffffff'
        },
        refreshValidation() {
            var fieldsValid = true
            let contentItems = this.getContentItems()
            for (let i = 0; i < contentItems.length; i++) {
                let contentItem = contentItems[i]
                if ((contentItem.show != null && contentItem.show === false) || !contentItem.required) continue

                if (contentItem.type == 'place_selector') {
                    if (!this.place || Object.keys(this.place).length === 0) {
                        fieldsValid = false
                        break
                    }
                } else if (contentItem.type == 'question_selector') {
                    if (!this.question || Object.keys(this.question).length === 0) {
                        fieldsValid = false
                        break
                    }
                }
            }
            this.inputIsValid = fieldsValid
        },
        async fetchConfig() {
            try {
                const response = await this.entryPointInitialData({
                    org_guid: this.orgGuid,
                    place_guid: this.placeGuid || null,
                    type: this.srType,
                })
                if (response && response.token) {
                    console.log(`got token info:`, response.token)
                    this.$store.commit('auth/setAnonymousToken', {
                        token: response.token.anonymous_token,
                        guid: response.token.guid
                    })
                }
                this.fullConfig = response.config
                let places = response.places
                places.forEach(place => {
                    place.value = place.guid
                    place.text = place.name
                    place.questions.forEach(question => {
                        question.value = question.guid
                    })
                })
                this.places = places
                if(places.length == 1) {
                    this.place = places[0]
                    this.onPlaceSelected(places[0])
                }
                console.log(response)
                this.applyCurrentConfig()
            } catch (error) {
                console.log(error)
                //todo
                switch (error.data.error.code) {
                    case 1021: //at least pin access required
                        this.navigateToAuth()
                        break;
                    case 1022: //access denied (current user has no access to this question)
                        this.navigateToNoAccess()
                        break;
                }
            }
        },
        navigateToAuth() {
            this.removeKeys()
            this.$router.push({
                name: 'SREntryPointAuth',
                params: {orgGuid: this.orgGuid},
                query: {t: this.srType, p: this.placeGuid,}
            })
        },
        navigateToNoAccess() {
            this.$router.push({
                name: 'SREntryPointNoAccess',
                params: {orgGuid: this.orgGuid},
                query: {t: this.srType, p: this.placeGuid,}
            })
        },
        afterLogout() {
            this.navigateToAuth()
        },
        applyCurrentConfig() {
            var config = this.fullConfig
            if (config.redirect && config.redirect.link) {
                window.location.replace(config.redirect.link);
                return
            }
            config.content = config.content.sort(function (q1, q2) {
                return q1.order - q2.order;
            });
            config.content.push({type: 'changer', value: 'a'})
            this.config = config
            this.refreshValidation()

            let showProfileIcon = true
            if (config.settings && config.settings.profile) {
                if (config.settings.profile.show_admin_menu != null) {
                    this.profileIconSettings.showAdminMenu = config.settings.profile.show_admin_menu
                }
                if (config.settings.profile.show != null) {
                    showProfileIcon = config.settings.profile.show
                }
            }
            this.showProfileIcon = showProfileIcon
            this.loaded = true
        },
        async sendLog(action, additionalData = null) {
            //todo??
            // await this.sendRemoteLogAction({
            //     srv_id: this.srvId,
            //     action: action,
            //     additional_data: additionalData,
            // })
        },
        async onSendClick(contentItem) {
            this.refreshValidation()
            if (!this.inputIsValid) {
                if (contentItem.inactive_message && contentItem.inactive_message != '') {
                    this.showErrorModal(contentItem.inactive_message, {duration: 1000})
                }
                return
            }
            //todo redirect
            this.$router.push({name: 'ServiceRequest', params: {questionId: this.question.guid, type: this.srType}})
        },
        shouldShowItem(contentItem) {
            return contentItem.show == null || contentItem.show == true
        },
        findContentItemByTag(tag) {
            return this.getContentItems().find(contentItem => contentItem.tag == tag)
        },
        onPlaceSelected(item) {
            this.question = {}
            this.questions = item.questions
            this.refreshValidation()
        },
        onQuestionSelected(item) {
            this.refreshValidation()
        },
    }

}
</script>

<style>
.dropdown-menu {
    z-index: 9999999 !important;
}

.ServiceRequest .comment_btn__wrapper.audio {
    right: 46px;
    bottom: 9px;
}

.ServiceRequest #container {
    bottom: -2px;
}

.ServiceRequest .spin {
    bottom: 5px;
    right: 40px;
}

.additional-dropdown {

}

.additional-dropdown li {
    width: 100%;
}

.additional-dropdown-toggle {
    background: white !important;
    border: 1px solid black;
    color: black !important;
}

.additional-dropdown-toggle::after {
    margin-left: 10px;
}
.ui.dropdown input {
    font-size: 16px !important;
}


</style>
<style scoped>
.ui.selection.dropdown {
    font-size: 16px;
}
.ServiceRequest {
    display: flex;
    padding-top: 16px;
    padding-bottom: 36px;
    padding-left: 16px;
    padding-right: 16px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    min-height: 100%;
}

.Request_wrapper {
    position: relative;
    width: 100%;
    display: flex;
}

.content {
    max-width: 500px;
    width: 100%;
    position: initial;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.inner-content::-webkit-scrollbar {
    display: none;
}

.inner-content {
    background: white;
    border-radius: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    padding-bottom: 16px;
    overflow: visible;
}

.place_img {
    width: auto;
    height: 70px;
    margin-top: 24px;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
}

.place_img img {
    width: auto;
    height: 70px;
    object-fit: cover;
}

.main_title {
    margin-top: 24px;
    font-size: 19px;
    margin-left: 24px;
    margin-right: 24px;
    text-align: center;
}

.subtitle {
    margin-top: 4px;
    font-size: 16px;
    margin-left: 16px;
    margin-right: 16px;
    text-align: center;
}

.bottom-space {
    margin-bottom: 8px;
}

.profile-photo {
    align-self: end;
    position: absolute;
    width: 36px;
    height: 36px;
    top: 12px;
    right: 12px;
}

.scan_qrs_button {
    background: #727272;
    border-radius: 4px;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 16px;
    margin-top: 16px;
    color: white;
    height: 44px;
    min-height: 44px;
    display: flex;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    cursor: pointer;
    max-width: 400px;
}

.main_button {
    background: #B95E5E;
    border-radius: 4px;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 16px;
    margin-top: 16px;
    color: white;
    height: 44px;
    min-height: 44px;
    display: flex;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    cursor: pointer;
    max-width: 400px;
}

.input-wrapper {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 16px;
    width: auto;
    margin-bottom: 0;
}

.input-wrapper.input {
    margin-top: 32px;
}

.input-wrapper.notes {
    margin-top: 28px;
}

.input-wrapper.notes .form-control {
    padding-right: 80px;
}

.input-wrapper.additional {
    display: flex;
    flex-direction: column;
}

.input-wrapper .dropdown-label {
    font-size: 14px;
}

.checkbox-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 15px;
    margin-top: 16px;
}

.checkbox-wrapper span {
    margin-left: 4px;
    margin-top: 5px;
    width: 100%;
    cursor: pointer;
}

.comment_btn__wrapper.photo {
    position: absolute;
    right: 8px;
    bottom: 7px;
    cursor: pointer;
}

.preview {
    height: 50px;
    padding-top: 4px;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 10px;
}

.preview img {
    max-width: 100%;
    max-height: 50px;
    padding-right: 5px;
}

.audio_wrapper {
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-left: 16px;
    margin-right: 16px;
}

audio {
    width: 90%;
    height: 40px;
}

.audio_delete {
    margin-left: 6px;
    cursor: pointer;
    padding: 6px;
}

/*________*/


input[type="checkbox"] {
    width: auto;
    margin-left: 0;
}

.input-label.dropdown {
    top: -14px !important;
    transition: all .3s ease;
    font-size: 14px;
}

.input-label {
    position: absolute;
    z-index: 999;
    top: 10px;
    pointer-events: none;
    transition: all .3s ease;
}

input:not(:placeholder-shown) ~ .input-label,
input:focus ~ .input-label {
    top: -15px;
    transition: all .3s ease;
    font-size: 14px;
}

.form-control {
    position: relative;
    border: none;
    border-bottom: 1px solid #2F2F2F;
    outline: none;
    border-radius: 0;
    padding-left: 0;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    color: black;
}

.form-control:focus {
    outline: none !important;
    text-decoration: none;
    box-shadow: none;
    border-color: #2F2F2F;
    color: black;
}

input::-webkit-calendar-picker-indicator {
    display: none;
}

.form-control::placeholder {
    font-size: 14px;
    color: #2F2F2F;
}

.form-control.simple::placeholder {
    font-size: 16px;
    color: #cdcdcd;
}

.form-control.simple {
    margin-top: 4px;
}

.photo-modal__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.photo-modal__image img {
    max-width: 100%;
    max-height: 250px;
}

.photo-modal__buttons {
    display: flex;
    justify-content: center;
    margin-top: 35px;
}

.photo-modal__change {
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-right: 25px;
}

.photo-modal__delete {
    width: 100%;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    color: #FFFFFF;
    background-color: #3F405C;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.content__wrapper {
    display: flex;
    justify-content: space-around;
    padding-top: 16px;
    width: 100%;
}

.rectangle-wrapper {
    margin-left: 16px;
    margin-right: 16px;
    width: 100%;
    cursor: pointer;
}

.rectangle {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 1px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    justify-content: center;
    height: 100%;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    aspect-ratio: 1;
    max-width: 100%;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
}

.rectangle-wrapper.left {
    margin-right: 8px;
}

.rectangle-wrapper.right {
    margin-left: 8px;
}

.rectangle.active {
    /*padding: 0;*/ /* ? removed to avoid text jumping when no icon and selected*/
}

.rectangle_img {
    max-width: 85px;
    max-height: 85px;
    margin-bottom: 20px;
}

.rect_btn_img {
    max-width: 60px;
    max-height: 60px;
    margin-bottom: 16px;
}

.check_icon {
    position: absolute;
    max-width: 32px;
    top: 2px;
    left: 5px;
}

.rect_close {
    max-width: 40px;
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 12px;
    padding-right: 12px;
    padding-left: 8px;
    padding-bottom: 8px;
}

.rect_close_back {
    width: 32px;
    height: 32px;
    position: absolute;
    aspect-ratio: 1;
    top: 6px;
    right: 6px;
    /*background: rgba(185, 94, 94, 0.40);*/
    background: rgb(131, 131, 131, 0.40);
    border-radius: 4px;
}

.rectangle-text {
    position: absolute;
    font-weight: bold;
    font-size: 17px;
    line-height: 18px;
    padding-top: 5px;
    padding-right: 10px;
    padding-bottom: 5px;
    margin-bottom: 7px;
    padding-left: 10px;
    text-align: center;
    /*white-space: nowrap;*/
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 96%;
    color: #424242;
    bottom: 0;
    border-radius: 4px;
}

.rectangle-text.active {
    color: #ffffff;
}

.rectangle-text__noicon {
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    padding: 5px 5px 5px;
    text-align: center;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow: hidden;
    max-width: 100%;
}

.rectangle-subtitle {
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    padding: 5px 5px 5px;
    text-align: center;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow: hidden;
    max-width: 100%;
}


@media screen and (min-width: 532px) {
    .content {
        margin: auto;
    }
}

@media screen and (min-width: 464px) {
    .main_button {
        margin-left: auto;
        margin-right: auto;
        min-width: 400px;
    }
}

@media screen and (max-width: 320px) {
    .rectangle-text {
        font-size: 14px;
        line-height: 14px;
        margin-bottom: 5px;
    }

    .rectangle_img {
        max-width: 70px;
        max-height: 70px;
    }

    .check_icon {
        max-width: 25px;
    }
}

@keyframes pulse {
    0% {
        box-shadow: 0px 0px 5px 0px rgba(173, 0, 0, .3);
    }
    65% {
        box-shadow: 0px 0px 5px 10px rgba(173, 0, 0, .3);
    }
    90% {
        box-shadow: 0px 0px 5px 10px rgba(173, 0, 0, 0);
    }
}
</style>
